'use strict';

///////////////////////////////////////
// Modal window

const modal = document.querySelector('.modal');
const overlay = document.querySelector('.overlay');
const btnCloseModal = document.querySelector('.btn--close-modal');
const btnsOpenModal = document.querySelectorAll('.btn--show-modal');
const tabs = document.querySelectorAll(`.operations__tab`);
const tabsContainer = document.querySelector(`.operations__tab-container`);
const tabsContent = document.querySelectorAll(`.operations__content`);
const nav = document.querySelector(`.nav`);

const openModal = function (e) {
  e.preventDefault();
  modal.classList.remove('hidden');
  overlay.classList.remove('hidden');
};

const closeModal = function () {
  modal.classList.add('hidden');

  overlay.classList.add('hidden');
};

btnsOpenModal.forEach(btn => btn.addEventListener(`click`, openModal));

btnCloseModal.addEventListener('click', closeModal);
overlay.addEventListener('click', closeModal);

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
    closeModal();
  }
});

// implementing smooth scrolling

const btnScrollTo = document.querySelector(`.btn--scroll-to`);
const section1 = document.querySelector(`#section--1`);

btnScrollTo.addEventListener(`click`, function (e) {
  const s1coords = section1.getBoundingClientRect();
  // console.log(s1coords);

  // console.log(e.target.getBoundingClientRect());

  // console.log(`current scroll (x/y)`, window.pageXOffset, window.pageYOffset);

  // console.log(
  //   `height/width viewport`,
  //   document.documentElement.clientHeight,
  //   document.documentElement.clientWidth
  // );

  //scrolling (method 1)
  // window.scrollTo({
  //   left: s1coords.left + window.pageXOffset,
  //   top: s1coords.top + window.pageYOffset,
  //   behavior: `smooth`,
  // });

  //modern
  section1.scrollIntoView({ behavior: `smooth` });
});
///////////////////////////
///     page navigation

// document.querySelectorAll(`.nav__link`).forEach(function (el) {
//   el.addEventListener(`click`, function (e) {
//     e.preventDefault();
//     const id = this.getAttribute(`href`);
//     console.log(id);
//     document.querySelector(id).scrollIntoView({ behavior: `smooth` });
//   });
// });

document.querySelector(`.nav__links`).addEventListener(`click`, function (e) {
  e.preventDefault();

  /// matching strategy
  if (e.target.classList.contains(`nav__link`)) {
    const id = e.target.getAttribute(`href`);
    console.log(id);
    document.querySelector(id).scrollIntoView({ behavior: `smooth` });
  }
});

//        tabbed component

tabsContainer.addEventListener(`click`, function (e) {
  const clicked = e.target.closest(`.operations__tab`);
  //console.log(clicked);

  //Guard clause
  if (!clicked) return;
  //active tab
  tabs.forEach(t => t.classList.remove(`operations__tab--active`));
  clicked.classList.add(`operations__tab--active`);

  //active tab content
  tabsContent.forEach(tc => tc.classList.remove(`operations__content--active`));
  document
    .querySelector(`.operations__content--${clicked.dataset.tab}`)
    .classList.add(`operations__content--active`);
});

//      menu fade animation

const hangOver = function (e) {
  if (e.target.classList.contains(`nav__link`)) {
    const link = e.target;
    //console.log(link);
    const siblings = link.closest(`.nav`).querySelectorAll(`.nav__link`);
    //console.log(siblings);
    const logo = link.closest(`.nav`).querySelector(`img`);

    siblings.forEach(el => {
      if (el !== link) el.style.opacity = this;
    });
    logo.style.opacity = this;
  }
};

nav.addEventListener(`mouseover`, hangOver.bind(0.5));
nav.addEventListener(`mouseout`, hangOver.bind(1));

// sticky navigation
const header = document.querySelector(`.header`);
const navHeight = nav.getBoundingClientRect().height;
const stickyNav = function (entries) {
  const [entry] = entries;

  if (!entry.isIntersecting) nav.classList.add(`sticky`);
  else nav.classList.remove(`sticky`);
};
const headerObserver = new IntersectionObserver(stickyNav, {
  root: null,
  threshold: 0,
  rootMargin: `-${navHeight}px`,
});

headerObserver.observe(header);

//      reveal section
const allSection = document.querySelectorAll(`.section`);
const revealSection = function (entries, observer) {
  const [entry] = entries;
  //gaurd clause
  if (!entry.isIntersecting) return;
  entry.target.classList.remove(`section--hidden`);
  observer.unobserve(entry.target);
};

const sectionObserver = new IntersectionObserver(revealSection, {
  root: null,
  threshold: 0.15,
});

allSection.forEach(function (section) {
  sectionObserver.observe(section);
  //section.classList.add(`section--hidden`);
});

//    lazy loading
const imgTargets = document.querySelectorAll(`img[data-src]`);
const loading = function (entries, observer) {
  const [entry] = entries;

  if (!entry.isIntersecting) return;
  entry.target.src = entry.target.dataset.src;
  entry.target.addEventListener(`load`, function () {
    entry.target.classList.remove(`lazy-img`);
  });
};
const imgObserver = new IntersectionObserver(loading, {
  root: null,
  thresold: 0,
  rootMargin: `-10px`,
});
imgTargets.forEach(img => imgObserver.observe(img));
//console.log(imgTargets);

//    slider
const slider = function () {
  const slides = document.querySelectorAll(`.slide`);
  const btnLeft = document.querySelector(`.slider__btn--left`);
  const btnRight = document.querySelector(`.slider__btn--right`);
  const dotContainer = document.querySelector(`.dots`);

  let curSlide = 0;
  const maxSlide = slides.length;
  const slider = document.querySelector(`.slider`);
  // slider.style.transform = `scale(0.4) translateX(-550px)`;
  // slider.style.overflow = `visible`;

  // Functions
  const createDots = function () {
    slides.forEach((s, i) =>
      dotContainer.insertAdjacentHTML(
        `beforeend`,
        `<button class="dots__dot" data-slide="${i}"></button>`
      )
    );
  };

  const activeDot = function (slide) {
    document
      .querySelectorAll(`.dots__dot`)
      .forEach(dot => dot.classList.remove(`dots__dot--active`));
    document
      .querySelector(`.dots__dot[data-slide="${slide}"]`)
      .classList.add(`dots__dot--active`);
  };

  const goToSlide = function (slide) {
    slides.forEach(
      (s, i) => (s.style.transform = `translateX(${100 * (i - slide)}%)`)
    );
  };

  //0% 100% 200% 300%

  const init = function () {
    createDots();
    activeDot(0);
    goToSlide(0);
  };
  init();
  //next slide
  const nextSlide = function () {
    if (curSlide === maxSlide - 1) {
      curSlide = 0;
    } else {
      curSlide++;
    }
    goToSlide(curSlide);
    activeDot(curSlide);
  };

  const previousSlide = function () {
    if (curSlide === 0) {
      curSlide = maxSlide - 1;
    } else {
      curSlide--;
    }
    goToSlide(curSlide);
    activeDot(curSlide);
  };

  //Event Handler
  btnRight.addEventListener(`click`, nextSlide);

  btnLeft.addEventListener(`click`, previousSlide);

  document.addEventListener(`keydown`, function (e) {
    //console.log(e);
    if (e.key === `ArrowRight`) {
      nextSlide();
    }
    if (e.key === `ArrowLeft`) {
      previousSlide();
    }

    //e.key ===`ArrowRight` && nextSlide()
    //e.key ===`ArrowLeft` && previousSlide()
  });
  dotContainer.addEventListener(`click`, function (e) {
    if (e.target.classList.contains(`dots__dot`)) {
      const { slide } = e.target.dataset;
      goToSlide(slide);
      activeDot(slide);
    }
  });
};
slider();
// /////////////////////////////////////////////////////////////////////////////////////////////
//              lectures
/*
////        dom traversing

const h1 = document.querySelector(`h1`);

// going downward : child
//console.log(h1.querySelectorAll(`.highlight`));

//console.log(h1.childNodes);
//console.log(h1.children);

h1.firstElementChild.style.color = `white`;
h1.lastElementChild.style.color = `orangered`;

//going upwards: parents
console.log(h1.parentNode);
console.log(h1.parentElement);

h1.closest(`.header`).style.background = `var(--gradient-secondary)`;
h1.closest(`h1`).style.background = `var(--gradient-primary)`;

//going sideways: siblings

console.log(h1.previousElementSibling);
console.log(h1.nextElementSibling);

//console.log(h1.previousSibling);
//console.log(h1.nextSibling);

console.log(h1.parentElement.children);

[...h1.parentElement.children].forEach(function (el) {
  if (el !== h1) el.style.transform = `scale(0.5)`;
});
/*
// rgb(255,255,255)

const randomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min);
const randomColor = () =>
  `rgb(${randomInt(0, 255)}, ${randomInt(0, 255)}, ${randomInt(0, 255)})`;

document.querySelector(`.nav__link`).addEventListener(`click`, function (e) {
  this.style.backgroundColor = randomColor();
  console.log(`LINK`, e.target, e.currentTarget);

  //stop propagation
  //e.stopPropagation();
});
document.querySelector(`.nav__links`).addEventListener(`click`, function (e) {
  this.style.backgroundColor = randomColor();
  console.log(`container`, e.target, e.currentTarget);
});
document.querySelector(`.nav`).addEventListener(`click`, function (e) {
  this.style.backgroundColor = randomColor();
  console.log(`nav`, e.target, e.currentTarget);
});


// type of event

const h1 = document.querySelector(`h1`);

// h1.onmouseenter = function (e) {
//   alert(`onmouseenter: great! your are reading the heading😎 `);
// };

const alertH1 = function (e) {
  alert(`addeventlistener: great! your are reading the heading😎.`);
};

h1.addEventListener(`mouseenter`, alertH1);
setTimeout(() => h1.removeEventListener(`mouseenter`, alertH1), 3000);


//            selecting element
//console.log(document.documentElement);
//console.log(document.body);
//console.log(document.head);
const header = document.querySelector(`.header`);
console.log(header);

const allSection = document.querySelectorAll(`.section`);
//console.log(allSection);

//console.log(document.getElementById(`section--1`));
const allButtons = document.getElementsByTagName(`button`);
//console.log(allButtons);

//console.log(document.getElementsByClassName(`btn`));

//            creating and inserting element
const html = `<p> i love you</p>`;
//header.insertAdjacentHTML(`afterbegin`, html);

const message = document.createElement(`div`);
message.classList.add(`cookie-message`);
message.innerHTML = `<p>We are cookies for improved Functionality and analytics.</p><button class="btn btn--close-cookie">Got It!</button>`;

//header.prepend(message);
//header.append(message.cloneNode(true));

//header.before(message);
header.after(message);

//          deleting element
document
  .querySelector(`.btn--close-cookie`)
  .addEventListener(`click`, function () {
    //message.remove();
    message.parentElement.removeChild(message);
  });

//                style
message.style.backgroundColor = `#37383d`;
message.style.width = `120%`;

//console.log(message.style.color);
console.log(message.style.backgroundColor);

console.log(getComputedStyle(message).color);
console.log(getComputedStyle(message).height);

message.style.height =
  Number.parseFloat(getComputedStyle(message).height, 10) + 20 + `px`;

document.documentElement.style.setProperty(`--color-primary`, `red`);

//                  attribute

const logo = document.querySelector(`.nav__logo`);

console.log(logo.alt);
console.log(logo.src);
console.log(logo.className);

logo.alt = `Beautiful minimalist logo`;
console.log(logo.alt);

//non-standard
console.log(logo.designer);
console.log(logo.getAttribute(`designer`));
console.log(logo.setAttribute(`company`, `bankist`));
console.log(logo.getAttribute(`company`));

console.log(logo.getAttribute(`src`));

const link = document.querySelector(`.twitter-link`);
console.log(link.href);
console.log(link.getAttribute(`href`));

//      data attribute
console.log(logo.dataset.versionNumber);

//        class
logo.classList.add(`c`, `j`);
logo.classList.remove(`c`, `j`);
logo.classList.toggle(`c`);
console.log(logo.classList.contains(`c`));

// dont use
logo.className = `jonas`;
*/
